import { useState } from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputBase from '@mui/material/InputBase';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import Backdrop from '@mui/material/Backdrop';

import styles from 'modules/report/styles/select-box-style';

const useStyles = makeStyles(styles);
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {},
  '& .MuiInputBase-input': {
    '@media screen and (min-width:1024px)': {
      height: '50px !important',
      width: '275px !important',
      borderRadius: '16px !important',
      fontSize: '20px !important',
      background: '#ffffff !important',
      boxShadow: '1px 1px 2px 0px #00000029 !important'
    },
    background: '#F5F5F5',
    border: '1px solid #FFFFFF',
    borderRadius: '98px',
    width: '100%',
    margin: '0 auto 0',
    boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: 'dana-bold',
    fontSize: '12px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#753CBE',
    height: '0',
    minHeight: '13px',
    paddingTop: '8px !important',
    paddingLeft: '20px !important',
    paddingRight: '40px !important',
    '&:focus': {
      background: '#F4F4F4',
      border: '1px solid #FFFFFF',
      borderRadius: '98px',
      margin: '0rem auto',
      boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)'
    }
  }
}));

const PaperProps = {
  sx: {
    marginTop: '6px',
    minHeight: '84px',
    background: '#F4F4F4',
    border: '1px solid #FFFFFF',
    boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1) ',
    borderRadius: '12px',
    '& ul': {
      height: '30px',
      display: 'grid',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '5px',
      marginTop: '4px'
    },
    '& li': {
      color: '#707070',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      textAlign: 'center',
      minWidth: '115px',
      background: '#FFFFFF',
      border: '1px solid #EEEEEE',
      boxShadow: '-2px -2px 10px #FFFFFF, 4px 4px 25px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
      marginBottom: '6px',
      fontSize: '10px',
      height: '30px ',
      minHeight: '30px'
    },
    '@media screen and (min-width:1024px)': {
      border: '1px solid #753CBE',
      '& ul': {
        height: '196px',
        display: 'grid',
        justifyContent: 'normal',
        padding: '24px',
        margin: 0,
        gap: '20px'
      },
      '& li': {
        height: '64px',
        width: '100%'
      }
    }
  }
};

const Icon = (props) => {
  const { style, ...otherProps } = props;
  const colorStyle = {
    color: '#707070',
    marginTop: '1px',
    marginRight: '8px'
  };
  const styles = { ...style, ...colorStyle };
  return <ExpandMoreIcon {...otherProps} style={styles} />;
};

export function CustomSelectBox(props) {
  const classes = useStyles();
  const { items, onChange, name, values } = props;

  const [open, setOpen] = useState(false);
  const [selectedItem, setselectedItem] = useState(values[name]);

  const handleToggle = () => setOpen(!open);

  const handleChange = (event) => {
    setselectedItem(event.target.value);
    onChange(event);
  };

  return (
    <>
      <Backdrop
        sx={{
          color: '#ffffff',
          zIndex: '10',
          background: 'rgba(216, 216, 216, 0.37)'
        }}
        open={open}
        onClick={() => setOpen(false)}
      />
      <FormControl sx={{ minWidth: '138px' }}>
        <Select
          name={name}
          id="demo-customized-select-native"
          value={selectedItem}
          onOpen={handleToggle}
          onClose={handleToggle}
          onChange={handleChange}
          IconComponent={Icon}
          input={<BootstrapInput />}
          MenuProps={{ PaperProps }}
        >
          {items.map((choice) => {
            return (
              <MenuItem
                dir="ltr"
                key={choice}
                value={choice}
                classes={{ selected: classes.ItemSelected }}
              >
                <div className={classes.numberWeight}>{choice}</div>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
}
